import React from "react";
import { StyleSheet, Dimensions, Platform } from "react-native";

import moment from "moment";

import Dialog from "../common/dialog";
import { Calendar } from "../common/calendar/index";
import Utils from "../../../helpers/utils";

export default function ResolutionTimeMachine({
  showDateDialog,
  selectedDate,
  onDateSelected = () => {},
  toggleDatePicker = () => {},
  controller = null,
}) {
  const dateSelected = (selectedDate
    ? moment(selectedDate)
    : Utils.nowUserTz(controller)
  ).format("YYYY-MM-DD");
  const today = Utils.nowUserTz(controller).format("YYYY-MM-DD");

  return (
    <>
      {showDateDialog ? (
        <Dialog.Container onClose={toggleDatePicker} showCloseButton>
          <Dialog.Title style={styles.dialogHeader}>
            Choose a day to go back in time and check out your past goals!
          </Dialog.Title>

          <Calendar
            theme={{
              backgroundColor: "#E6F9F3",
              calendarBackground: "#FFF",
              textSectionTitleColor: "#b6c1cd",
              textSectionTitleDisabledColor: "#d9e1e8",
              selectedDayTextColor: "#ffffff",
              dayTextColor: "#2d4150",
              arrowColor: "#000",
              monthTextColor: "#000",
              textDayFontWeight: "400",
              textMonthFontWeight: "bold",
              textDayFontSize: 16,
              textMonthFontSize: 16,
              textDayHeaderFontSize: 16,
            }}
            markedDates={{
              [dateSelected]: {
                selected: true,
                backgroundColor: "#41A9CE",
                color: "#FFF",
              },
            }}
            current={dateSelected}
            maxDate={today}
            monthFormat={"MMMM yyyy"}
            onDayPress={(day) => onDateSelected(day.dateString)}
            firstDay={7}
          />
        </Dialog.Container>
      ) : null}
    </>
  );
}

const styles = StyleSheet.create({
  dialogHeader: {
    fontFamily:  Platform.select({ default: "Montserrat", android: "Montserrat-Regular" }),
    fontWeight: "500",
    fontSize: 14,
    lineHeight: 17,
    letterSpacing: 0.175,
    color: "#000",
    textAlign: "center",
  },
});
